<template>
  <div style="text-align: center">
    <t-icon style="font-size: 20px;color: var(--td-text-color-primary)" name="notification"/>
    <!-- <audio id="callAudio" controls>
      <source src="../../assets/audio/temp.wav" type="audio/wav">
    </audio> -->
  </div>
</template>

<script>
import {getDataJson, pollingRefresh} from "@/utils/refresh-cpt-data";
import {compareByOperator} from "@/utils/threshold-compare";

export default {
  name: "cpt-audio",
  props: {
    option: Object,
    components: Array, 
    current: Object
  },
  data() {
    return {
      cptData: {},
      uuid: null,
      audio: null,
      synth: null,
      utterance: null,
    }
  },
  computed: {
    dataReload() {
      return this.option.attribute.globalDataReload || [0]
    },
  },
  watch: {
    "current.cptShow"(val) {
      console.log('text-show-', val);
      if (val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
    "option.attribute.hideCompInTab"(val) {
      // 组合选项卡内显示时
      if (!val && this.dataReload.includes(1)) {
        this.refreshCptData();
      }
    },
  },
  created() {
    this.uuid = require('uuid').v1();
    // 新增属性兼容旧代码
    const attr = this.option.attribute
    if (!attr.globalDataReload) attr.globalDataReload = [0]
    //判断此控件在九宫格里面就不请求数据
    if(this.current.cptOption.interaction.fatherGridId && isFromGrid != 'ninegrid')return 
    if (this.dataReload.includes(0)) {
      this.refreshCptData();
    }
  },
  // mounted() {
  //   var audioRef = document.getElementById('callAudio');
  //   if(audioRef) {
  //     audioRef.click();
  //     audioRef.play();
  //   };
  // },
  methods: {
    refreshCptData(cptDataForm = this.option.cptDataForm,paras) {
      pollingRefresh(this.uuid, cptDataForm, () => {
        this.loadData(cptDataForm,paras)
      },this.components)
    },
    loadData(cptDataForm,paras) {
      const that = this;
      that.stopAudio()
      getDataJson(cptDataForm,paras,(res)=> {
        const attr = that.option.attribute
        that.cptData = res;
        if(attr.alarmConfig.threshold){//告警判断
          const res = compareByOperator(attr.alarmConfig.operator,that.cptData.value,attr.alarmConfig.threshold)
          if(res){
            if(that.cptData.audioText){
              that.synth = window.speechSynthesis;
              that.playText()
              if(attr.loop){
                that.utterance.onend = () => {
                  that.playText()
                }
              }
            }else{
              that.playAudio(attr)
            }
          }
        }

      })
    },
    playAudio(attr) {
      try {
        this.stopAudio();
        this.audio = new Audio();
        this.audio.src = attr.audioSrc;
        if(attr.loop){
          this.audio.loop = "loop";
        }
        this.audio.play();
      } catch (error) {
        console.log('音频播放错误: ', error)
      }
    },
    playText(){
      if(!this.utterance){
        this.utterance = new SpeechSynthesisUtterance();
      }
      this.utterance.text = this.cptData.audioText
      this.synth.speak(this.utterance);
    },
    stopAudio() {
      if(this.audio){
        this.audio.pause();
      }
      if(this.synth){
        this.synth.cancel();
        this.utterance.onend = null
      }
    },
  }
}
</script>

<style scoped>

</style>
